import { render, staticRenderFns } from "./DeliveryDay.vue?vue&type=template&id=3b614aae&"
import script from "./DeliveryDay.vue?vue&type=script&lang=js&"
export * from "./DeliveryDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports